import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import "ulysses/features/admin";

"use strict";
ko.bindingHandlers.ruleseditor = {
    init:function(elt, va, allbindings, model, context) {
        var editorModel = ko.unwrap(va());
        if (typeof ko.unwrap(editorModel.rules) == "string") {
            editorModel.rules = ko.observableArray(JSON.parse(ko.unwrap(editorModel.rules)));
        } else if (!ko.isObservable(editorModel.rules)) {
            editorModel.rules = ko.observableArray(editorModel.rules);
        }
        var child_context = context.createChildContext(editorModel);
        ko.applyBindingsToDescendants(child_context, elt);
        return { "controlsDescendantBindings":true};
    }
};

ko.bindingHandlers.ruleview = {
    init: function(elt, va, allbindings, model, context) {
        try {
            var rule_data = ko.unwrap(va());
            
            console.log("got rule data:", rule_data, ko.toJS(rule_data));
            var rule_model = $.extend({}, rule_data, {
                "lock": ko.observable(false),
                "loading_rules": ko.observable(false),
                "loading_fields": ko.observable(false)
            });
            $.extend(rule_model, {
                "available_fields":ko.computed(function() {
                    var res = Promise.Deferred();
                    res.always(function() {
                        setTimeout(function() { rule_model.loading_fields(false); }, 0);
                    });
                    rule_model.loading_fields(true);
                    var entity = ko.unwrap(context.$parent.target);
                    if (!entity) return res.resolve([]);
                    
                    var models = uly.api.start().follow("uly:models").follow("find", {"rel":entity});
                    Promise.when(models.follow("uly:attributes"), models.follow("uly:relations"))
                        .then(function([attributes, relations]) {
                            var values = $.merge(
                                $.merge([], attributes).sort(function(a,b) { return a.name > b.name ? 1 : a.name < b.name ? -1 : 0; }),
                                $.map(
                                    relations.filter(function(r) {
                                        return !r.multiplicity || r.multiplicity == "one";
                                    }),
                                    function(val){
                                        return val;
                                        //return $.extend({}, val, { "caption": "<b><i class='fa fa-link' ></i>"+val.caption+"</b>" });
                                    }
                                ).sort(function(a,b) { return a.name > b.name ? 1 : a.name < b.name ? -1 : 0; })
                            );
                            values.push({ "name": "actions_depended_on", "caption": "Template Needed First"});
                            console.log("got values:", values, $.map(values, function(val, idx) { return val ? val.name : null; }));
                            
                            res.resolve(values);
                        }).fail(function(result) {
                            res.reject(result);
                        });
                    return res;
                }).extend({"async": true}),
                "available_rules":ko.computed(function() {
                    var entity = ko.unwrap(context.$parent.target);
                    var field = ko.unwrap(rule_data.target_field);
                    var source = ko.unwrap(context.$parent.source);
                    if (!entity || !field) return Promise.Deferred().resolve([]);
                    rule_model.loading_rules(true);
                    return uly.api.start().follow("uly:templaterules")
                        .follow("find", { "entity":entity, "target_field":field, "source":source })
                        .follow("item")
                        .always(function() {
                            setTimeout(function() {rule_model.loading_rules(false); }, 0);
                        });
                }).extend({"async": true})
            });
            if (ko.isObservable(rule_model.target_field)) {
                rule_model.target_field.subscribe(function() {
                    rule_model.lock((rule_model.lock()||0)+1);
                    setTimeout(function(){ rule_model.lock((rule_model.lock()||0)-1); }, 0);
                });
            }
            if (!ko.isObservable(rule_model.rule))
                rule_model.rule = ko.observable(ko.unwrap(rule_model.rule));
            rule_model.rule.subscribe(function() {
                rule_model.lock((rule_model.lock()||0)+1);
                setTimeout(function(){ rule_model.lock((rule_model.lock()||0)-1); }, 0);
            });
            rule_model.selected_rule_data = ko.computed(function() {
                console.error("recalculating selected rule data:",  ko.unwrap(rule_data.rule), rule_data, rule_model);
                var rule = ko.unwrap(rule_data.rule);
                var matching_rules = $.grep(ko.unwrap(rule_model.available_rules), function(r) { return r.name == rule; });
                var rule_info = null;
                if (matching_rules.length > 0) {
                    rule_info = matching_rules[0];
                }
                return rule_info;
            });
            rule_model.args = ko.computed(function() {
                var args = ko.unwrap(rule_data.args);
                var old_args = args;
                var rule_info = ko.unwrap(rule_model.selected_rule_data);
                if (rule_info) {
                    console.log("rule_info.args:", rule_info.args);
                    var server_args = ko.mapping.fromJS(rule_info.args ||{});
                    
                    var new_args = $.extend({}, server_args);
                    $.each(new_args, function(key, value) {
                        if (args && args[key] && typeof args[key] == "function") {
                            new_args[key] = args[key];
                        }
                    });
                    args = new_args;
                    //and now update the real args.
                    if (ko.isObservable(rule_data.args)) {
                        if (!ko.unwrap(rule_data.args)) {
                            rule_data.args(args);
                        } else {
                            var old_args = ko.unwrap(rule_data.args);
                            $.each(old_args, function(key, value) {
                                if (typeof args[key] != "function") 
                                    delete old_args[key];
                            });
                            $.each(args, function(key, value) {
                                args[key] = value;
                            });
                            
                        }
                    }
                    else
                    {
                        rule_data.args = args;
                    }
                }
                return args;
            });
            rule_model.arg_view = ko.computed(function() {
                var rule_info = ko.unwrap(rule_model.selected_rule_data);
                if (rule_info) {
                    return rule_info.arg_view;
                }
                return null;
            });

            var child_context = context.createChildContext(rule_model);
            ko.applyBindingsToDescendants(child_context, elt);
        } catch(e) { console.error(e); throw e; }
        return {"controlsDescendantBindings":true};
    }
};

ko.bindingHandlers.ruleselector = {
    init: function() {
        return { controlsDescendantBindings: true };
    },
    update: function(elt, va, allbindings, model, context) {
        var rule_data = ko.unwrap(va());
        var target_class = ko.unwrap(rule_data.target);
        var target_field = ko.unwrap(rule_data.field);
        var source_class = ko.unwrap(rule_data.source);
        var args = rule_data.args;
        var arg_view = rule_data.arg_view;

        var rule = ko.unwrap(va());

        var available_rules = uly.api.start().follow("uly:templaterules")
                .follow("find", { "entity":target_class, "target_field":target_field})
                .follow("item")
                .then(function(rules) {
                    $(elt).empty().unbind();
                    if(rules != null){
                        for(var i=0; i< rules.length;i++){
                            var r = rules[i];
                            for (var j in r)
                                $("<option></option>").attr({"value":j}).data("view", r[j]).text(r[j].caption || r[j].name).appendTo($(elt));
                        }
                        $(elt).on("change", function(e){
                            e.preventDefault();
                            var selected_rule = $(this).find(":selected");
                            if(rule != selected_rule.val()) {
                                rule_data.rule(selected_rule.val());
                            }
                            else {
                                var selected_rule_data = selected_rule.data("view");
                                arg_view(selected_rule_data.arg_view);
                                //update args.
                                var current_args = JSON.parse(ko.utils.unwrapObservable(rule_data.args_)) || {};
                                var new_args = selected_rule_data.args || {};
                                current_args = $.extend(new_args, current_args);
                                rule_data.args_(ko.toJSON(current_args));
                                ko.bindingHandlers.availableargs.init($args_container[0],valueAccessor,allBindingsAccessor,viewModel,bindingContext,selected_rule_data);
                            }
                            $args_container.show();
                            return false;
                        });
                        if (rule !== null){
                            $(elt).find("option[value="+rule+"]").attr({"selected" : "selected"});
                            $(elt).select2("destroy").select2({allowClear: true});
                        }
                        else{
                            $(elt).find("option:first").attr({"selected":"selected"});
                        }
                        $(elt).trigger("change");
                    }
                    else if (rule !== null){
                        rule_data.rule(null);
                    }
                    else $(elt).next().hide();
                });
    }
};

$.extend(uly.actions, {
    addrule: function(ev, $elt, ui) {
        ui.model.rules.push({
            "rule":ko.observable(null),
            "source":ko.observable(ko.unwrap(ui.model.source)),
            "target_field":ko.observable(null),
            "args":ko.observable(null),
            "arg_view":ko.observable(null)
        });
    },
    removerule: function(ev, $elt, ui) {
        console.log("removal:", ui, ui.model);
        var rule = ui.context.$parent;
        var rules = ui.context.$parents[1].rules;
        rules.remove(rule);
    }
});
